var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0C4.47714 0 0 4.47714 0 10C0 15.5229 4.47714 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47714 15.5229 0 10 0ZM10 1.42857C14.7262 1.42857 18.5714 5.27381 18.5714 10C18.5714 14.7262 14.7262 18.5714 10 18.5714C5.27381 18.5714 1.42857 14.7262 1.42857 10C1.42857 5.27381 5.27381 1.42857 10 1.42857ZM7.61952 10.0471C7.61277 9.72656 7.67107 9.40794 7.79089 9.11052C7.91071 8.81309 8.08957 8.54304 8.31667 8.31667C8.54299 8.0895 8.81303 7.9106 9.11047 7.79077C9.4079 7.67095 9.72655 7.61269 10.0471 7.61952L14.7138 5.28619L12.3805 9.95286C12.3872 10.2734 12.3289 10.5921 12.2091 10.8895C12.0893 11.1869 11.9104 11.457 11.6833 11.6833C11.457 11.9106 11.1868 12.0895 10.8893 12.2093C10.5918 12.3291 10.2731 12.3874 9.95238 12.3805L5.28571 14.7138L7.61952 10.0471ZM10 9.04762C9.75262 9.05544 9.518 9.15921 9.34578 9.33696C9.17356 9.51471 9.07726 9.7525 9.07726 10C9.07726 10.2475 9.17356 10.4853 9.34578 10.663C9.518 10.8408 9.75262 10.9446 10 10.9524C10.2474 10.9446 10.482 10.8408 10.6542 10.663C10.8264 10.4853 10.9227 10.2475 10.9227 10C10.9227 9.7525 10.8264 9.51471 10.6542 9.33696C10.482 9.15921 10.2474 9.05544 10 9.04762Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.bf4e9c58bd0ab175dbaaf605bc9fad84.svg";
export { ForwardRef as ReactComponent };